import { defineMessages } from "react-intl";

export default defineMessages({
  duplicateAsianumero: {
    id: "error.duplicateAsianumero",
    defaultMessage: "Asianumero on jo käytössä toisella muutospyynnöllä"
  },
  muutospyyntoNotFound: {
    id: "error.muutospyyntoNotFound",
    defaultMessage: "Muutospyyntöä ei löytynyt"
  },
  virheLatauksessa: {
    id: "error.virheLatauksessa",
    defaultMessage: "Virhe tietojen latauksessa"
  }
});
